import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import ProductCouponList from '../component/fpg/list/ProductCouponList'
import FilterActiveIcon from '../icons/filteractiveicon'
import FilterIcon from '../icons/filtericon'
import PlusIcon from '../icons/plusicon'
import MainLayout from '../mainLayout'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../redux/bindActionCretor'
//moment import
import moment from "moment-timezone";
//Service import
import service from "../services";
let sub;

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};
class Productcouponlist extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            getLastUpdated: '',
            loaderFlag: false,
            data:[
                {
                    "label":"product list",
                    "Content":"This is content for Tab 1",
                }
            ],
            productData: [],
            isDisable:false
        }
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    };

    componentDidMount() {
        this.getProductLastUpdate();
        this.getLastUpdatedTimeandDate();
         this.setState({
           loaderFlag: true,
         });
       }
    
       getProductLastUpdate = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch(response.event){
                case 'ticketCms|products|getLastUpdated':
                    this.setState({
                        getLastUpdated : response.data
                    })
                    break;
                case 'ticketCms|products|changeOrder':
                    if(!response.error){
                        this.apiserve.success('Updated Successfully.')
                    }
                    break;
            }
        })
    }

    getLastUpdatedTimeandDate = () => {
        this.apiserve.sendevent("ticketCms|products|getLastUpdated", { type: 1 });
    }

    AddPage = () => {
        this.props.ProductEditList('');
        this.props.history.push(`/product-detail`)
    }

    updateList = () => {
        this.apiserve.sendevent("ticketCms|products|changeOrder", this.state.productData);
    }

    updateData = (data) => {
        this.setState({productData:data})
    } 

    updateDisable = (val) => {
        this.setState({isDisable:val})
    } 
    
    
    render() {
        const { getLastUpdated,isDisable } = this.state;
        var updateAt = new Date(getLastUpdated && getLastUpdated.updatedAt);
        var hour = moment.tz(updateAt, "US/Mountain").format("h");
        var minutes = moment.tz(updateAt, "US/Mountain").format("mm");
        var state = moment.tz(updateAt,"US/Mountain").format("A");
        var updatedBy = getLastUpdated && getLastUpdated.updatedBy;
        return (
            <React.Fragment>
                <div className="right_side_wrapper">
                    <ul className="fpg_admin_tab disp_flex">
                        {
                            this.state.data && this.state.data.map((list,index) => {
                                return(
                                    <li className="active" >
                                        <p className="uppercase text_left">
                                         <div>{list.label}</div>
                                         <button disabled={isDisable} className='sd_update_list_btn' onClick={() => this.updateList()}>Update List</button>
                                         <span id={index} onClick={()=>this.AddPage()}><PlusIcon /></span>
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </ul>
                   
                    <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
                        <p></p>
                        <p className="update_date">Last Update: {hour}:{minutes} {state} -{" "}
                        {moment.tz(updateAt,"US/Mountain").format("MM/DD/YYYY")} Last Updated By:{" "}
                        {updatedBy && updatedBy.fname} {updatedBy && updatedBy.lname}</p>
                    </div>
                    <div className="table_wrap product_list_tbl film_list_table striped_table">
                        <ProductCouponList history={this.props.history} productData={this.updateData} isDisable={this.updateDisable}/>
                    </div>                               
                </div>
        </React.Fragment>  
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Productcouponlist);
